import { Component, Renderer2, Input, ViewChild, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';

var _c0 = ["bcElement"];
var /** @type {?} */ jsbarcode = require('jsbarcode');
var NgxBarcodeComponent = /** @class */ (function () {
    /**
     * @param {?} renderer
     */
    function NgxBarcodeComponent(renderer) {
        this.renderer = renderer;
        this.elementType = 'svg';
        this.cssClass = 'barcode'; // this should be done more elegantly
        this.format = 'CODE128';
        this.lineColor = '#000000';
        this.width = 2;
        this.height = 100;
        this.displayValue = false;
        this.fontOptions = '';
        this.font = 'monospace';
        this.textAlign = 'center';
        this.textPosition = 'bottom';
        this.textMargin = 2;
        this.fontSize = 20;
        this.background = '#ffffff';
        this.margin = 10;
        this.marginTop = 10;
        this.marginBottom = 10;
        this.marginLeft = 10;
        this.marginRight = 10;
        this.value = '';
        this.valid = function () { return true; };
    }
    Object.defineProperty(NgxBarcodeComponent.prototype, "options", {
        /**
         * @return {?}
         */
        get: function () {
            return {
                format: this.format,
                lineColor: this.lineColor,
                width: this.width,
                height: this.height,
                displayValue: this.displayValue,
                fontOptions: this.fontOptions,
                font: this.font,
                textAlign: this.textAlign,
                textPosition: this.textPosition,
                textMargin: this.textMargin,
                fontSize: this.fontSize,
                background: this.background,
                margin: this.margin,
                marginTop: this.marginTop,
                marginBottom: this.marginBottom,
                marginLeft: this.marginLeft,
                marginRight: this.marginRight,
                valid: this.valid,
            };
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NgxBarcodeComponent.prototype.ngOnChanges = function () {
        this.createBarcode();
    };
    /**
     * @return {?}
     */
    NgxBarcodeComponent.prototype.createBarcode = function () {
        if (!this.value) {
            return;
        }
        var /** @type {?} */ element;
        switch (this.elementType) {
            case 'img':
                element = this.renderer.createElement('img');
                break;
            case 'canvas':
                element = this.renderer.createElement('canvas');
                break;
            case 'svg':
            default:
                element = this.renderer.createElement('svg', 'svg');
        }
        jsbarcode(element, this.value, this.options);
        for (var _i = 0, _a = this.bcElement.nativeElement.childNodes; _i < _a.length; _i++) {
            var node = _a[_i];
            this.renderer.removeChild(this.bcElement.nativeElement, node);
        }
        this.renderer.appendChild(this.bcElement.nativeElement, element);
    };
    /**
     * @nocollapse
     */
    NgxBarcodeComponent.ctorParameters = function () { return [
        { type: Renderer2, },
    ]; };
    NgxBarcodeComponent.propDecorators = {
        'elementType': [{ type: Input, args: ['bc-element-type',] },],
        'cssClass': [{ type: Input, args: ['bc-class',] },],
        'format': [{ type: Input, args: ['bc-format',] },],
        'lineColor': [{ type: Input, args: ['bc-line-color',] },],
        'width': [{ type: Input, args: ['bc-width',] },],
        'height': [{ type: Input, args: ['bc-height',] },],
        'displayValue': [{ type: Input, args: ['bc-display-value',] },],
        'fontOptions': [{ type: Input, args: ['bc-font-options',] },],
        'font': [{ type: Input, args: ['bc-font',] },],
        'textAlign': [{ type: Input, args: ['bc-text-align',] },],
        'textPosition': [{ type: Input, args: ['bc-text-position',] },],
        'textMargin': [{ type: Input, args: ['bc-text-margin',] },],
        'fontSize': [{ type: Input, args: ['bc-font-size',] },],
        'background': [{ type: Input, args: ['bc-background',] },],
        'margin': [{ type: Input, args: ['bc-margin',] },],
        'marginTop': [{ type: Input, args: ['bc-margin-top',] },],
        'marginBottom': [{ type: Input, args: ['bc-margin-bottom',] },],
        'marginLeft': [{ type: Input, args: ['bc-margin-left',] },],
        'marginRight': [{ type: Input, args: ['bc-margin-right',] },],
        'value': [{ type: Input, args: ['bc-value',] },],
        'bcElement': [{ type: ViewChild, args: ['bcElement', /** @type {?} */ ({ static: true }),] },],
        'valid': [{ type: Input, args: ['bc-valid',] },],
    };
NgxBarcodeComponent.ɵfac = function NgxBarcodeComponent_Factory(t) { return new (t || NgxBarcodeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NgxBarcodeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxBarcodeComponent, selectors: [["ngx-barcode"]], viewQuery: function NgxBarcodeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bcElement = _t.first);
    } }, inputs: { elementType: ["bc-element-type", "elementType"], cssClass: ["bc-class", "cssClass"], format: ["bc-format", "format"], lineColor: ["bc-line-color", "lineColor"], width: ["bc-width", "width"], height: ["bc-height", "height"], displayValue: ["bc-display-value", "displayValue"], fontOptions: ["bc-font-options", "fontOptions"], font: ["bc-font", "font"], textAlign: ["bc-text-align", "textAlign"], textPosition: ["bc-text-position", "textPosition"], textMargin: ["bc-text-margin", "textMargin"], fontSize: ["bc-font-size", "fontSize"], background: ["bc-background", "background"], margin: ["bc-margin", "margin"], marginTop: ["bc-margin-top", "marginTop"], marginBottom: ["bc-margin-bottom", "marginBottom"], marginLeft: ["bc-margin-left", "marginLeft"], marginRight: ["bc-margin-right", "marginRight"], value: ["bc-value", "value"], valid: ["bc-valid", "valid"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["bcElement", ""]], template: function NgxBarcodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", null, 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.cssClass);
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxBarcodeComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-barcode',
                template: "<div #bcElement [class]=\"cssClass\"></div>",
                styles: []
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { elementType: [{
            type: Input,
            args: ['bc-element-type']
        }], cssClass: [{
            type: Input,
            args: ['bc-class']
        }], format: [{
            type: Input,
            args: ['bc-format']
        }], lineColor: [{
            type: Input,
            args: ['bc-line-color']
        }], width: [{
            type: Input,
            args: ['bc-width']
        }], height: [{
            type: Input,
            args: ['bc-height']
        }], displayValue: [{
            type: Input,
            args: ['bc-display-value']
        }], fontOptions: [{
            type: Input,
            args: ['bc-font-options']
        }], font: [{
            type: Input,
            args: ['bc-font']
        }], textAlign: [{
            type: Input,
            args: ['bc-text-align']
        }], textPosition: [{
            type: Input,
            args: ['bc-text-position']
        }], textMargin: [{
            type: Input,
            args: ['bc-text-margin']
        }], fontSize: [{
            type: Input,
            args: ['bc-font-size']
        }], background: [{
            type: Input,
            args: ['bc-background']
        }], margin: [{
            type: Input,
            args: ['bc-margin']
        }], marginTop: [{
            type: Input,
            args: ['bc-margin-top']
        }], marginBottom: [{
            type: Input,
            args: ['bc-margin-bottom']
        }], marginLeft: [{
            type: Input,
            args: ['bc-margin-left']
        }], marginRight: [{
            type: Input,
            args: ['bc-margin-right']
        }], value: [{
            type: Input,
            args: ['bc-value']
        }], valid: [{
            type: Input,
            args: ['bc-valid']
        }], bcElement: [{
            type: ViewChild,
            args: ['bcElement', /** @type {?} */ ({ static: true })]
        }] }); })();
    return NgxBarcodeComponent;
}());

var NgxBarcodeModule = /** @class */ (function () {
    function NgxBarcodeModule() {
    }
    /**
     * @return {?}
     */
    NgxBarcodeModule.forRoot = function () {
        return {
            ngModule: NgxBarcodeModule,
            providers: []
        };
    };
    /**
     * @nocollapse
     */
    NgxBarcodeModule.ctorParameters = function () { return []; };
NgxBarcodeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxBarcodeModule });
NgxBarcodeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxBarcodeModule_Factory(t) { return new (t || NgxBarcodeModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxBarcodeModule, { declarations: [NgxBarcodeComponent], exports: [NgxBarcodeComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxBarcodeModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [
                    NgxBarcodeComponent,
                ],
                exports: [
                    NgxBarcodeComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return NgxBarcodeModule;
}());

export { NgxBarcodeModule, NgxBarcodeComponent };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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